import TextMessageTemplate from './TextMessageTemplate';

// TECH-2730 / Workstream B. Organisation-level default message templates.
// Same document shape as TextMessageTemplate, but stored in the
// OrganisationMessageTemplates collection keyed by organisationId.
class OrganisationMessageTemplate extends TextMessageTemplate {}

OrganisationMessageTemplate.collection = 'OrganisationMessageTemplates';

export default OrganisationMessageTemplate;
